import { ProviderType } from "@wags/catalog/pure.ts";
import type { ReactNode } from "react";
import {
    deriveListingHealth,
    ListingHealthSection,
    type mergeListingPage,
} from "@/features/listings";
import {
    type DogPageSectionsProps,
    ListingSections,
} from "./dog-page-sections";

type MergedListing = ReturnType<typeof mergeListingPage>;

export function DogListingDetails({
    listing,
    providerType,
    providerName,
    included,
    sectionProps,
    recommendations,
}: {
    listing: MergedListing;
    providerType: ProviderType;
    providerName?: string;
    included?: string[];
    sectionProps: DogPageSectionsProps;
    recommendations: ReactNode;
}) {
    return (
        <>
            <DogListingHealth
                listing={listing}
                providerType={providerType}
                providerName={providerName}
                included={included}
            />
            <ListingSections {...sectionProps} />
            {recommendations}
        </>
    );
}

function DogListingHealth({
    listing,
    providerType,
    providerName,
    included,
}: {
    listing: MergedListing;
    providerType: ProviderType;
    providerName?: string;
    included?: string[];
}) {
    if (!listing) return null;

    const health = deriveListingHealth({
        providerKind:
            providerType === ProviderType.ShelterRescue
                ? "shelter_rescue"
                : providerType === ProviderType.Breeder
                  ? "breeder"
                  : null,
        sexLabel: listing.sexLabel,
        providerName,
        healthTests: listing.healthTests ?? [],
        completedCare: listing.completedCare ?? [],
        reportedHealth: listing.reportedHealth ?? [],
        included: included ?? [],
        description: listing.description ?? "",
    });

    if (!health) return null;

    return <ListingHealthSection health={health} />;
}
